import React, { useState } from "react";
import SideBar from "./SideBar";
import TopBar from "./TopBar";
import { fmtDay } from "./aces/Shared";
import * as Yup from "yup";
import Modal from "react-bootstrap/Modal";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import PermissionsModal from "./aces/PermissionsModal";

interface Props {
  alluserList: any[];
  role: string | null;
  showAddModal: boolean;
  loading: boolean;
  mainLoading: boolean;
  allDeparmentList: any[];
  searchName: string;
  setSearchName: (val: string) => void;
  searchEmail: string;
  setSearchEmail: (val: string) => void;
  searchDepartment: string;
  setSearchDepartment: (val: string) => void;
  searchStatus: string;
  setSearchStatus: (val: string) => void;
  searchRole: string;
  errorMsg: string
  setSearchRole: (val: string) => void;
  onPressHandleModal: () => void;
  onPressAddEmployee: (values: any) => Promise<void>;
  updateUserStatus: (values: any) => Promise<void>;
}
const UserManagment = ({
  alluserList,
  role,
  onPressAddEmployee,
  showAddModal,
  onPressHandleModal,
  loading,
  mainLoading,
  updateUserStatus,
  allDeparmentList,
  setSearchName,
  setSearchEmail,
  setSearchDepartment,
  setSearchStatus,
  searchName,
  searchEmail,
  searchDepartment,
  searchStatus,
  setSearchRole,
  searchRole,
  errorMsg
}: Props) => {
  const isVisible =
    role?.toLowerCase() === "admin" || role?.toLowerCase() === "user_manager";
  const [permissionUser, setPermissionUser] = useState<{ id: number; name: string } | null>(null);
  const initialValues = {
    name: "",
    email: "",
    password: "",
    department: "",
    type: "EMPLOYEE", // default value
  };

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string().email("Invalid email").required("Email is required"),
    password: Yup.string()
      .min(6, "Min 6 characters")
      .required("Password is required"),
    department: Yup.string().required("Department is required"),
    type: Yup.string().required("Type is required"),
  });
  const { t } = useTranslation();
  const [showPassword, setShowPassword] = useState(false);

  return (
    <>
      <PermissionsModal user={permissionUser} onClose={() => setPermissionUser(null)} />
      <Modal
        show={showAddModal}
        onHide={onPressHandleModal}
        centered
        backdrop="static"
        keyboard={false}
        className="__modal"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Add Employee</Modal.Title> */}
          <Modal.Title>{t("usermanagement.add_employee")}</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={async (values, { resetForm }) => {
            await onPressAddEmployee(values);
            resetForm();
          }}
        >
          {() => (
            <Form className="__userForm">
              <Modal.Body>
                <div className="__inputField">
                  <label>{t("usermanagement.name")}</label>
                  <Field name="name" type="text" />
                  <ErrorMessage
                    name="name"
                    component="div"
                    render={() => (
                      <div className="error-text">
                        {t("usermanagement.errors.name_required")}
                      </div>
                    )}
                  />
                </div>
                <div className="__inputField">
                  <label>{t("usermanagement.email")}</label>
                  <Field name="email" type="email" />
                  <ErrorMessage
                    name="email"
                    component="div"
                    render={() => (
                      <div className="error-text">
                        {t("usermanagement.errors.email_required")}
                      </div>
                    )}
                  />
                </div>
                <div className="__inputField">
                  <label>{t("usermanagement.password")}</label>
                  <div className="passwordParent">
                    <Field
                      name="password"
                      type={showPassword ? "text" : "password"}
                    />
                    <div
                      className="watchPassword"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      <i
                        className={
                          showPassword ? "ri-eye-off-line" : "ri-eye-line"
                        }
                      ></i>
                    </div>
                  </div>
                  <ErrorMessage
                    name="password"
                    component="div"
                    render={() => (
                      <div className="error-text">
                        {t("usermanagement.errors.password_required")}
                      </div>
                    )}
                  />
                </div>
                <div className="__inputField">
                  <label>{t("usermanagement.department")}</label>
                  <Field name="department">
                    {({ field, form }: any) => (
                      <input
                        type="text"
                        list="departmentOptions"
                        {...field}
                        onChange={(e) =>
                          form.setFieldValue("department", e.target.value)
                        }
                        placeholder={t("usermanagement.enter_or_select_dept")}
                      />
                    )}
                  </Field>

                  <datalist id="departmentOptions">
                    {allDeparmentList?.map((dept: string, index: number) => (
                      <option key={index} value={dept} />
                    ))}
                  </datalist>

                  <ErrorMessage
                    name="department"
                    component="div"
                    render={() => (
                      <div className="error-text">
                        {t("usermanagement.errors.department_required")}
                      </div>
                    )}
                  />
                </div>

                <div className="__inputField">
                  <label>{t("usermanagement.type")}</label>
                  <Field as="select" name="type">
                    <option value="EMPLOYEE">
                      {t("usermanagement.employee")}
                    </option>
                    <option value="MANAGER">
                      {t("usermanagement.manager")}
                    </option>
                  </Field>
                  <ErrorMessage
                    name="type"
                    component="div"
                    render={() => (
                      <div className="error-text">
                        {t("usermanagement.errors.type_required")}
                      </div>
                    )}
                  />
                </div>
                  { errorMsg&& <div className="error" style={{textAlign:'center'}}>{errorMsg}</div>}
              </Modal.Body>
              <Modal.Footer>
                <button type="submit" className="submit__btn">
                  {loading ? (
                    <Spinner animation="border" role="status" size="sm">
                      <span className="visually-hidden">
                        {t("common.loading")}
                      </span>
                    </Spinner>
                  ) : null}
                  {loading ? ` ${t("common.submitting")}` : t("common.submit")}
                </button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
      <div className="__dashboard">
        <div className="__dashboard__wrapper">
          <SideBar />
          <div className="__dashboardRightSide">
            <TopBar />
            <div className="__dashboardContent">
              <div className="__pageHeading">
                {isVisible
                  ? t("usermanagement.employee_mgmt")
                  : t("usermanagement.user_mgmt")}
              </div>
              <div className="__myTraining">
                <div className="billingTop">
                  <div className="statusSelec"></div>
                  <div className="csv_pdf">
                    {/* <button className="csv">Export to CSV</button>
                    <button className="pdf_btn">Export to PDF</button> */}
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-12 col-12">
                    {isVisible && (
                      <div
                        className="createChecklist"
                        onClick={onPressHandleModal}
                      >
                        <button>{t("usermanagement.add_employee")}</button>
                      </div>
                    )}
                    <div className="form__paremt">
                      <div className="formFields">
                        <div className="__input__group">
                          <label>{t("usermanagement.search_name")}</label>
                          <input
                            type="text"
                            placeholder={t("usermanagement.enter_name")}
                            value={searchName}
                            onChange={(e) => setSearchName(e.target.value)}
                          />
                        </div>

                        <div className="__input__group">
                          <label>{t("usermanagement.search_email")}</label>
                          <input
                            type="text"
                            placeholder={t("usermanagement.enter_email")}
                            value={searchEmail}
                            onChange={(e) => setSearchEmail(e.target.value)}
                          />
                        </div>

                        <div className="__input__group">
                          <label>{t("usermanagement.search_dept")}</label>
                          <input
                            type="text"
                            placeholder={t("usermanagement.enter_dept")}
                            value={searchDepartment}
                            onChange={(e) =>
                              setSearchDepartment(e.target.value)
                            }
                          />
                        </div>

                        <div className="__input__group">
                          <label>{t("usermanagement.search_status")}</label>
                          <select
                            value={searchStatus}
                            onChange={(e) => setSearchStatus(e.target.value)}
                          >
                            <option value="">{t("dropdown.all")}</option>
                            <option value="ACTIVE">
                              {t("dropdown.active")}
                            </option>
                            <option value="INACTIVE">
                              {t("dropdown.inactive")}
                            </option>
                          </select>
                        </div>

                        <div className="__input__group">
                          <label>{t("usermanagement.search_role")}</label>
                          <select
                            value={searchRole}
                            onChange={(e) => setSearchRole(e.target.value)}
                          >
                            <option value="">{t("dropdown.all")}</option>
                            <option value="USER">{t("dropdown.user")}</option>
                            <option value="ADMIN">{t("dropdown.admin")}</option>
                            <option value="USER_MANAGER">
                              {t("dropdown.user_manager")}
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="__defaultTable">
                      <table>
                        <thead>
                          <tr>
                            <th>{t("usermanagement.username")}</th>
                            <th>{t("usermanagement.email")}</th>
                            <th>{t("usermanagement.department")}</th>
                            <th>{t("usermanagement.company")}</th>
                            <th>{t("usermanagement.number")}</th>
                            <th>{t("usermanagement.address")}</th>
                            <th>{t("usermanagement.vat")}</th>
                            <th>{t("usermanagement.status")}</th>
                            <th>{t("usermanagement.role")}</th>
                            <th>{t("usermanagement.registered")}</th>
                            <th>{t("usermanagement.action")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {mainLoading ? (
                            <tr>
                              <td colSpan={11} style={{ textAlign: "center" }}>
                                <Spinner
                                  animation="border"
                                  role="status"
                                  size="sm"
                                >
                                  <span className="visually-hidden">
                                    {t("common.loading")}
                                  </span>
                                </Spinner>{" "}
                                Loading users...
                              </td>
                            </tr>
                          ) : alluserList?.length > 0 ? (
                            alluserList.map((user, index) => (
                              <tr key={user.id || index}>
                                <td>
                                  <div className="flex-gap">
                                    <div className="usernameIcon">
                                      {user.name?.charAt(0).toUpperCase() ||
                                        "U"}
                                    </div>
                                    {user.name}
                                  </div>
                                </td>
                                <td className="email_cell">{user.email}</td>
                                <td
                                  className={!user.department ? "is-dash" : ""}
                                >
                                  {user.department || "-"}
                                </td>
                                <td className={!user.company ? "is-dash" : ""}>
                                  {user.company || "-"}
                                </td>
                                <td className={!user.number ? "is-dash" : ""}>
                                  {user.number || "-"}
                                </td>
                                <td className={!user.address ? "is-dash" : ""}>
                                  {user.address || "-"}
                                </td>
                                <td
                                  className={!user.vatNumber ? "is-dash" : ""}
                                >
                                  {user.vatNumber || "-"}
                                </td>
                                <td>{user.status}</td>
                                <td>
                                  <button
                                    className={
                                      user.role === "ADMIN"
                                        ? "administrator"
                                        : "employee"
                                    }
                                  >
                                    {user.role}
                                  </button>
                                </td>
                                <td>
                                  {fmtDay(user.createdAt)}
                                </td>
                                <td>
                                  {loading ? (
                                    <button
                                      className={
                                        user.status.toLowerCase() === "active"
                                          ? "overdue_btn"
                                          : "paid_btn"
                                      }
                                    >
                                      <Spinner animation="border" size="sm" />
                                    </button>
                                  ) : (
                                    <button
                                      className={
                                        user.status.toLowerCase() === "active"
                                          ? "overdue_btn"
                                          : "paid_btn"
                                      }
                                      onClick={() =>
                                        updateUserStatus({
                                          id: user.id,
                                          status:
                                            user.status.toLowerCase() ===
                                            "active"
                                              ? "REJECTED"
                                              : "ACTIVE",
                                        })
                                      }
                                    >
                                      {user.status.toLowerCase() === "active"
                                        ? "Inactive"
                                        : "Active"}
                                    </button>
                                  )}
                                  {role === "ADMIN" && user.role === "USER_MANAGER" && (
                                    <button
                                      className="aces-btn small secondary"
                                      style={{ marginLeft: 6 }}
                                      title={t("aces.permissions.title")}
                                      onClick={() => setPermissionUser({ id: user.id, name: user.name })}
                                    >
                                      <i className="ri-shield-user-line"></i>
                                    </button>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td className="nofound text-center" colSpan={11}>
                                {t("usermanagement.no_users")}
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserManagment;
